// extracted by mini-css-extract-plugin
export default {"resource":"resource___OrWVY","object":"object___oOTEa","exhibit":"exhibit___xbsrJ"};